import React, { useState, useEffect,useContext } from "react";
import style from "../../../styles/mystyle.module.css";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import * as config from "../../../next.config.js";
import axios from "axios";
import Link from "next/link";
import { constants } from "../../../constants";
import SeeMore from "../SeeMore";
import  {ManipulateSearchOfArabicLetters} from "../../helpers/ManipulateSearchOfArabicLetters"
import {
  getCookieValue
} from "../../helpers/helpers";
import { useCart } from "../../../context/cart/use-cart";
import Loading from "../../components/Loaders/Loading";
import TermsContext from "../../../context/Trems"
import {getImage} from '../../helpers/images'
import {getTermsByVocabCodes} from '../../helpers/global/term/term'
import {CustomeCheckbox} from './Blog.style'
function Blogsection({ blogType, searchBlogName, blogsIds, entityId }) {
  const router = useRouter();
  const { locale } = useRouter();
  const [pageTitle, setPageTitle] = useState("");
  const vocabTerms= useContext(TermsContext)
  const [loading, setLoading] = React.useState(false);
  const [limit, setLimit] = React.useState(25);
  const [pageId, setPageId] = React.useState(0);
  const [lstBlog, setLstBlog] = React.useState([]);
  const [showSeeMore, setShowSeeMore] = useState(false);
  const [NotFound, setNotFound] = useState(false);
  const [Images, setImages] = useState([]);
  const [showloading, setShowloading] = useState(true);
  const {
  
    removeItem,
    addItem,
    getItem
  } = useCart();
  let blogtypeCode = "";
  const fileTypes = ["jpeg", "png", "jpg"];

  let blogTypeCodeLst = [];
  
  const getBlogs = async (pageNumber, SearchBlogName) => {
    setPageId(pageNumber);
    let tempData = [];
    let status;


    if (blogType == "medical-advices") {
      blogTypeCodeLst = ["medical-advices"];
    } else if (blogType == "articles") {
      blogTypeCodeLst = ["articles"];
    } else if (blogType == "news") {
      blogTypeCodeLst = ["news"];
    } else {
      blogTypeCodeLst = ["articles", "medical-advices"];
    }
    if (blogsIds && blogsIds.length > 0) {
      blogTypeCodeLst = ["articles", "medical-advices", "news"];
    }
        status = vocabTerms.statusIds;
        setShowloading(true);
            let blogypesRes=await  getTermsByVocabCodes(["blog-types"])
            let blogTypes=JSON.parse(blogypesRes)
            let blogTypesIds = blogTypes? blogTypes &&blogTypes.filter(ele => blogTypeCodeLst.includes(ele.code)).map(ele => ele.id): null;
            blogTypesIds = Array.from(new Set(blogTypesIds));
            let tempLstBlogs = [];

            let searchData = {
              langId: locale,
              blogTypeCode: blogTypesIds,
              statusId: (status),
              limit: limit,
              pageId: pageNumber,
              getBlogSlug: ""
            };
            if (entityId) {
              searchData.entityDetailsId = entityId;
            }
            if (blogsIds && blogsIds.length > 0) {
              searchData.id = blogsIds;
            }

            if (SearchBlogName == null &&lstBlog && lstBlog.length > 0) {
              if(blogsIds&&blogsIds.length==0){

             
              let blogIds = lstBlog.map(i => i.id);

              searchData.notblogIds = blogIds;
            }
            }

            if (
              SearchBlogName &&
              SearchBlogName != " " &&
              SearchBlogName != null
            ) {
              searchData["title"] =  SearchBlogName;


            }

            if (router.query.tag && router.query.tag != null) {
              searchData.tagid = router.query.tag;
            }
            axios
              .post(`${config["basePath"]}/${constants.BLOGS_URL}`, {
                data: searchData
              })
              .then(async blogs => {
                // console.log("blogs=======>",blogs)
                setLoading(false);
                tempLstBlogs = blogs.data.data.data;
                if (tempLstBlogs.length > 0) {
                  await axios
                    .get(`${config["basePath"]}/api/cms/blog/getFiles`, {
                      params: {
                        blogId: JSON.stringify(
                          tempLstBlogs.map(item => item.id)
                        )
                      }
                    })
                    .then(blogFiles => {
                     
                      let tmepblogFiles = blogFiles.data.data.data;

                      if (tmepblogFiles.length > 0) {
                        tmepblogFiles.map(async x => {
                          if (x.blogFiles.filter(i => i.files != null).length) {
                              let img=await getImage(x.blogFiles.filter(
                                          i => i.files != null
                                        )[0].files.fileId,x.blogFiles.filter(
                                                    i => i.files != null
                                                  )[0].files.filePath)
                                      
                                let resImage = [
                                  { image: img, blogId: x.blogId }
                                ];

                                setImages(prev => [...prev, ...resImage]);
                          }
                        });
                      }
                    })
                    .catch(err => err);

                  if (pageNumber > 1) {
                    setLstBlog(prev => [...prev, ...tempLstBlogs]);
                  } else {
                    setLstBlog([...tempLstBlogs]);
                  }
                  setShowloading(false);
                } else {
                  setShowSeeMore(false);
                  setNotFound(true);
                  setShowloading(false);
                }

                if (limit == blogs.data.data.pageable.numberOfElements) {
                  if (limit * pageId < blogs.data.data.pageable.totalElements) {
                    setShowSeeMore(true);
                  } else {
                    setShowSeeMore(false);
                    setNotFound(true);
                  }
                }
              })
              .catch(err => err);
  
  };
  React.useEffect(() => {
    setNotFound(false);
    setPageId(1)
    setLstBlog([]);
    if (blogType == "news") {
      blogtypeCode = "news";
      setPageTitle(t("News"));
    } else if (blogType == "articles") {
      blogtypeCode = "articles";
      setPageTitle(t("Articals"));
    } else if (blogType == "medical-advices") {
      blogtypeCode = "medical-advices";
      setPageTitle(t("MedicalAdvices"));
    } else {
      blogtypeCode = "articles";
      setPageTitle(t("Blogs"));
    }

    if (searchBlogName != null) {
      setLstBlog([]);
      getBlogs(1, searchBlogName);

      setShowSeeMore(false);
      setNotFound(false);
    } else {
      setLstBlog([]);
      getBlogs(1);
      setShowSeeMore(false);
      setNotFound(false);
    }
    
    // console.log("blogsIds========>",blogsIds)
  }, [blogType, searchBlogName,blogsIds]);


  const getMore = async() => {
    setLoading(true);
    let pageNumber = pageId + 1;
    await getBlogs(pageNumber);
  };

  const { t } = useTranslation("common");

  return (
    <div className={style.SectionContainer}>
      <div className={style.allcard}>
        <h3 className={style.headerBlog}> {t(`${pageTitle}`)} </h3>

        <div className={style.cardsBlog}>
          {lstBlog && lstBlog.length
            ? lstBlog.map(item => {
            
                return (
                  <div
                    className={
                      style.cardBlog +
                      " " +
                      style.relativePosition +
                      " " +
                      style.Blogwidth
                    }
                  >
                    <div className={style.markandheartproduct}>
                      <img
                        // className={style.markproduct}
                        // className={style.markproduct}
                        className='w-9'
                        src={`${config.basePath}/assest/Myfav.svg`}
                      ></img>
                             <div className='absolute left-0 right-0 top-0'>
                      <CustomeCheckbox
                        icon={
                          <img
                          className='w-6'
                          // className={style.StarBorderDiet + " " + style.heartproduct}
                            src={`${config.basePath}/assest/OutlineStar.svg`}
                          ></img>
                        }
                        onClick={e => {
                
                          if (e.target.checked == true) {
                            addItem({
                              type: "blogs",
                              // subType: constants.favoriteBlogs,
                              entityId: item.id,
                              isFavoriate: true,
                              quantity: 0,
                              productUnitPrice: null,
                              entityDetailsId: item.id,
                              userCountry: getCookieValue("userCountry")
                            });
                          } else if (e.target.checked == false) {
                            removeItem({
                              type: "blogs",
                              // subType: constants.favoriteBlogs,
                              entityId: item.id,
                              isFavoriate: false,
                              quantity: 0,
                              productUnitPrice: null,
                              entityDetailsId: item.id,
                              userCountry: getCookieValue("userCountry")
                            });
                          }
                        }}
                        checked={
                          getItem(item.id,null,item.id ,getCookieValue("userCountry")) != null &&
                          getItem(item.id,null,item.id,getCookieValue("userCountry")).isFavoriate == true
                        }
                      
                        checkedIcon={
                          <img
                          className='w-6'
                          // className={style.StarDiet + " " + style.heartproduct}
                            src={`${config.basePath}/assest/Fullstar.svg`}
                          ></img>
                        }
                        // className={style.heartproduct}
                      />
                      </div>
                    </div>

                    <Link
                      href={`${constants.blogsLink}/[type]/[Details]`}
                      as={`${constants.blogsLink}/${item.blogTypes[0].code}/${
                        item.slug.length > 0 &&
                        item.slug.filter(
                          i =>
                            i.active == true &&
                            i.language &&
                            i.language.code == router.locale
                        ).length > 0
                          ? item.slug.filter(
                              i =>
                                i.active == true &&
                                i.language &&
                                i.language.code == router.locale
                            )[0].url
                          : item.id
                      } `.replace("/[^a-zA-Z0-9-_]/g", "")}
                      className={style.AtagIcon}
                    >
                      {/* <a > */}
                        {Images &&
                        Images.length > 0 &&
                        Images.filter(i => i.blogId == item.id).length > 0 &&
                        Images.filter(i => i.blogId == item.id)[0].image !=
                          "" ? (
                          <img
                            className={style.imgBlog}
                            src={
                              Images &&
                              Images.filter(i => i.blogId == item.id)[0].image
                            }
                          ></img>
                        ) : (
                          <img
                            className={style.imgBlog}
                            src={`${config.basePath}/assest/defaultBlogImage.svg`}
                          ></img>
                        )}
                      {/* </a> */}
                    </Link>
                    <div className={style.TextBlogSection}>
                      <Link
                        href={`${constants.blogsLink}/[type]/[Details]`}
                        as={`${constants.blogsLink}/${item.blogTypes[0].code}/${
                          item.slug.length > 0 &&
                          item.slug.filter(
                            i =>
                              i.active == true &&
                              i.language &&
                              i.language.code == router.locale
                          ).length > 0
                            ? item.slug.filter(
                                i =>
                                  i.active == true &&
                                  i.language &&
                                  i.language.code == router.locale
                              )[0].url
                            : item.id
                        } `.replace("/[^a-zA-Z0-9-_]/g", "")}
                        className={style.AtagIcon + " " + style.hoverLink}
                      >
                        {/* <a > */}
                          <div
                            className={style.blogh4 + " " + style.paddingtext}
                          >
                            {item.transBlog[0].title}
                          </div>
                        {/* </a> */}
                      </Link>
                      <div className={style.blogh4 + " " + style.paddingtext}>
                        {item.blogTypes.filter(
                          i => i.language.code == router.locale
                        ).length > 0
                          ? item.blogTypes.filter(
                              i => i.language.code == router.locale
                            )[0].name
                          : ""}
                      </div>
                      <p className={style.textblog + " " + style.paddingtext}>
                        {item.transBlog[0].body.length > 100
                          ? item.transBlog[0].body
                              .replace(/<([^>]+)>|\&nbsp;/gi, "")
                              .substr(0, 50) + " ..."
                          : item.transBlog[0].body}
                      </p>
                    </div>
                  </div>
                );
              })
            : ""}
        </div>
        {/*  <button  className={style.SeeMore}>{t("SeeMore")}</button> */}
        {/* <div className={style.paddingBottom}></div> */}
        <div style={{ textAlign: "center" }}>
          {" "}
 
          {showloading ? <Loading start={showloading}/> : ""}
        </div>
        {lstBlog.length > 0 && showSeeMore == true ? (
          <>
          <div className={style.paddingBottom}></div>
          <SeeMore loading={loading} getMore={async ()=>await getMore()} />
          <div className={style.paddingBottom}></div>
          </>
        ) : (
          ""
        )}

        {NotFound == true ? (
          <p style={{ textAlign: "center", fontSize: " 1.2rem" }}>
            {" "}
            {t("Notfound")}
          </p>
        ) : (
          ""
        )}
      </div>
    </div>
  );
}

export default Blogsection;
